export default function parseCsv(text: string): string[][] {
  if (!text) {
    return []
  }

  // Remove BOM if present (common in Windows CSV exports)
  text = text.replace(/^\uFEFF/, '')

  // 1️⃣ Split into rows
  const rows = text.trim().split(/\r?\n/).filter(r => r.trim().length > 0)
  if (rows.length === 0) {
    return []
  }

  // 2️⃣ Detect delimiter (comma vs semicolon)
  const sample = rows[0]
  const commaCount = (sample.match(/,/g) || []).length
  const semicolonCount = (sample.match(/;/g) || []).length
  const delimiter = semicolonCount > commaCount ? ';' : ','

  // 3️⃣ Parse a single CSV line (handles quotes, commas, escaped quotes)
  const parseCsvLine = (line: string): string[] => {
    const result: string[] = []
    let current = ''
    let insideQuotes = false

    for (let i = 0; i < line.length; i++) {
      const char = line[i]

      if (char === '"') {
        if (insideQuotes && line[i + 1] === '"') {
          // Escaped double quote
          current += '"'
          i++
        } else {
          insideQuotes = !insideQuotes
        }
      } else if (char === delimiter && !insideQuotes) {
        result.push(current.trim())
        current = ''
      } else {
        current += char
      }
    }

    result.push(current.trim())
    return result
  }

  // 4️⃣ Parse all rows
  const parsedRows = rows.map(parseCsvLine)

  // 5️⃣ Pad shorter rows with empty strings for consistency
  const maxColumns = Math.max(...parsedRows.map(r => r.length))
  return parsedRows.map(values => {
    while (values.length < maxColumns) {
      values.push('')
    }
    return values
  })
}
